module.exports = __webpack_public_path__ + "img/image167.5175a922.png";